import { TCreateReservationParams } from '../../../types/services';
import { asyncTimeout } from '../../../utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from '../../../utils/constants';

export const createReservation = async (
  params: TCreateReservationParams
): Promise<void> => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
